import { useUnit } from 'effector-react'
import type { DateRange } from 'react-day-picker'
import { useMutation, useQueryClient } from 'react-query'

import { useToast } from '@/components/ui/toast.tsx'
import { $creatorId, loadCreatorsFx } from '@/models/creators.ts'
import { SubscriberAnalysisService } from '@/modules/tracking/new-subscriber-analysis/service'
import { handleError } from '@/utils/error'

export function useCreateHighSpenderListMutation(
  dateRange: DateRange,
  spendLimit: number,
) {
  const queryClient = useQueryClient()
  const creatorId = useUnit($creatorId)
  const toast = useToast()

  return useMutation(
    (name: string) =>
      SubscriberAnalysisService.createHighSpenderList(
        name,
        creatorId!,
        dateRange.from || new Date(),
        dateRange.to || new Date(),
        spendLimit,
      ),
    {
      onSuccess: () => {
        loadCreatorsFx()
        queryClient.invalidateQueries(['creator'])
        toast.success('List created successfully')
      },
      onError: (error) => {
        handleError(
          error,
          'Something went wrong while creating high spender list',
        )
        loadCreatorsFx()
        queryClient.invalidateQueries(['creator'])
      },
    },
  )
}
